// constants/menuItems.js
import { Image, PenTool, Video, MessageSquareMore, AudioLines, Music, PaintbrushVertical, MonitorSmartphone, Proportions, Wand2 } from 'lucide-react';

export const sections = {
	'Generieren': {
		image: {
			icon: Image,
			label: 'Bild',
			color: 'bg-indigo-300',
			link: 'tools/image',
			category: 'generate',
		},

		illustration: {
			icon: PenTool,
			label: 'Illustration',
			color: 'bg-green-500',
			link: 'tools/illustration',
			category: 'generate',
		},

		video: {
			icon: Video,
			label: 'Video',
			color: 'bg-orange-500',
			link: 'tools/video',
			category: 'generate',
		},

		text: {
			icon: MessageSquareMore,
			label: 'Text',
			color: 'bg-cyan-500',
			link: 'tools/text',
			category: 'generate',
		},

		speech: {
			icon: AudioLines,
			label: 'Sprache',
			color: 'bg-stone-500',
			link: 'tools/speech',
			category: 'generate',
		},

		audio: {
			icon: Music,
			label: 'Musik',
			color: 'bg-red-600',
			link: 'tools/audio',
			category: 'generate'
		},

		asset: {
			icon: PaintbrushVertical,
			label: 'Asset',
			color: 'bg-slate-700',
			link: 'tools/asset',
			category: 'generate',
		},

		website: {
			icon: MonitorSmartphone,
			label: 'Website',
			color: 'bg-emerald-500',
			link: 'tools/website',
			category: 'generate',
		},
	},

	'Bearbeiten': {
		upscale: {
			icon: Proportions,
			label: 'Skalieren',
			color: 'bg-yellow-500',
			link: 'tools/upscale',
			category: 'edit',
		},

		'edit-image': {
			icon: Wand2,
			label: 'Bearbeiten',
			color: 'bg-purple-600',
			link: 'tools/edit-image',
			category: 'edit',
		},
	}
};

export const toolCategories = {
	companyOwned: 'Lizenzierte Tools',
	free: 'Kostenfreie Tools'
}

// Hilfsfunktionen für die Listen
export const generateItems = Object.values(sections).filter(section => section.category === 'generate');
export const editItems = Object.values(sections).filter(section => section.category === 'edit');